<template>
  <div>
    <!--导航栏 start-->
    <van-nav-bar
      left-text="返回"
      fixed
      title="门店信息"
      left-arrow
      @click-left="onClickLeft"
    >
      <!--通过插槽自定义导航栏右侧的内容 start-->
      <template #right>
        <van-icon name="wap-home-o" size="20" @click="onClickRight" />
      </template>
      <!--通过插槽自定义导航栏右侧的内容 end-->
    </van-nav-bar>
    <!--导航栏 end-->
    <!--内容 start-->

    <div style="margin-top: 1.5rem">
      <van-dropdown-menu>
        <van-dropdown-item ref="item" :title="store_name">
          <div v-for="(bububu, index) in option1" :key="index">
            <van-cell
              @click="outlet(bububu.id, bububu.store_name)"
              :title="bububu.store_name"
              is-link
            />
          </div>
        </van-dropdown-item>
      </van-dropdown-menu>
      <van-cell title="门店编号" :value="list.store_num" />
        <van-cell title="门店名称" :value="list.store_name" />
      <van-cell title="门店联系人" :value="list.store_contact" />
      <van-cell title="联系人电话" :value="list.store_tel" />
      <van-cell title="D0结算费率" :value="list.d0_rate" />
      <!-- <van-cell title="D1结算费率" :value="list.d1_rate" /> -->
      <van-cell title="入驻时间" :value="list.create_time" />
    </div>
    <!--内容 end-->
  </div>
</template>

<script>
export default {
  name: "StoreInformation", //门店信息
  data() {
    return {
      // 门店id
      store_id: "",
      store_name: "",
      option1: [],
      list: [],
    };
  },
  methods: {
    // 返回上一级
    onClickLeft() {
      // 返回商户信息
      this.$router.push("/MerchantInformation");
    },
    // 右侧icon跳转至商户首页
    onClickRight() {
      // 返回商户首页
      this.$router.push("/MerchantHomepage");
    },

    //门店选择
    outlet(a, b) {
      this.store_id = a;
      this.store_name = b;
      console.log(a, b);
      this.$refs.item.toggle();
      this.choose();
    },
    //全部门店列表
    theStores() {
      this.$http
        .get("/wechat/user/get_merchant_list", {
          params: {
            merchant_id: window.sessionStorage.getItem("commercialId"),
          },
        })
        .then((response) => {
          console.log(response.data.data);
          this.option1 = response.data.data;
          this.number();
          this.choose();
        });
    },
    //默认会选择第一家门店
    number() {
      if (this.store_id == "") {
        this.store_id = this.option1[0].id;
        this.store_name = this.option1[0].store_name;
      }
    },
    //选择每个门店
    choose() {
      this.$http
        .get("/wechat/api.merchant_info/get_store_info", {
          params: {
            merchant_id: window.sessionStorage.getItem("commercialId"),
            store_id: this.store_id,
          },
        })
        .then((response) => {
          console.log(response.data.data);
          this.list = response.data.data;
        });
    },
  },
  mounted() {
    this.theStores();
  },
};
</script>

<style scoped>
::v-deep .van-popup{
       overflow-y: auto!important;
}
</style>